import { render, staticRenderFns } from "./BlockCard.vue?vue&type=template&id=c6e969aa&"
import script from "./BlockCard.vue?vue&type=script&lang=js&"
export * from "./BlockCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports